module.exports = __webpack_public_path__ + "assets/img/5移仓.73566a69.png";